export default "__VITE_ASSET__692320a2__"